"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CloseIconSquareButton;

var _react = _interopRequireDefault(require("react"));

var _emotion = require("emotion");

var _themeConfig = _interopRequireDefault(require("@lyearn-team/theme-config"));

var _Icon = _interopRequireDefault(require("../../Icon"));

var _DarkButton = _interopRequireDefault(require("../../Button/DarkButton"));

var s = {
  closeIconSquareButtonWrapper:
  /*#__PURE__*/
  (0, _emotion.css)("padding:6px 6px 6px 6px !important;svg{fill:white !important;width:14px !important;height:14px !important;}")
};

var closeIconButtonClick = function closeIconButtonClick(e, onCloseIconButton) {
  e.stopPropagation();
  e.preventDefault();
  onCloseIconButton();
};

function CloseIconSquareButton(props) {
  var onCloseIconButton = props.onCloseIconButton,
      _props$size = props.size,
      size = _props$size === void 0 ? '19px' : _props$size;
  return _react.default.createElement(_DarkButton.default.SecondaryButton, {
    className: s.closeIconSquareButtonWrapper,
    withIcon: true,
    onClick: function onClick(e) {
      return closeIconButtonClick(e, onCloseIconButton);
    },
    size: "small"
  }, _react.default.createElement(_Icon.default, {
    style: {
      height: size,
      width: size,
      fill: _themeConfig.default.color.dark.iron
    },
    type: "close"
  }));
}